import moment from 'moment';
import QRCode from 'qrcode.react';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Card, Form, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';

import Table1 from '../../../components/Common/TableContainer';
import { Expander } from '../../../components/Common/Expander';
import { TestOfSamplesTabModal } from './TestOfSamplesTabModal';
import TableNP from '../../../components/Common/TableContainerNP';
import { LabOperationTestEditModal } from './LabOperationTestEditModal';
import { getLabRequestTests, updateLabRequestTest } from '../../../store/actions';
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal';
import { AnalysisRequestLastUpdate } from '../../../components/Common/AnalysisRequestLastUpdate';
import { AnalysisRequestSaveButton } from '../../../components/Common/AnalysisRequestSaveButton';
import { AnalysisRequestNotifyButton } from '../../../components/Common/AnalysisRequestNotifyButton';
import { ConfirmationModalTestReport } from '../../../components/Common/ConfirmationModalTestReport';
import { AnalysisRequestNewRegisterButton } from '../../../components/Common/AnalysisRequestNewRegisterButton';
import { BaseCustomButton } from '../../../shared';
import { userRoles } from '../../../shared';
// Formik validation
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { statuses, requestStatus } from '../../../constants';

export const LabOperationTab = ({ props, id, labRequest, updateLabOperationStatus, generalStatus, status }) => {

  const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''

  // Modal para Agregar Ensayo
  const [showModal1, setShowModal1] = useState(false);

  const [showModal2, setShowModal2] = useState(false);
  const [showModal3, setShowModal3] = useState(false);

  const [confirmationModal, setConfirmationModal] = useState(false);

  // Para establecer los datos de la fila seleccionada para editar o eliminar
  const [rowInfo, setRowInfo] = useState();

  const [activeTab, setActiveTab] = useState('1'); // Cambia entre ? perfiles

  const booleanValidation = React.useMemo(
    () => generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED,
    [generalStatus]
  );

  const profiletoggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  }

  // * Redux
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}&isInLaboratoryOperations=yes`)); // TODO: Aqui falta meter que filtre por el "flag"
  }, [])

  const { labRequestTests, loading, labRequestTest, total, currentPage, labRequestReqs } = useSelector(state => ({
    labRequestTests: state.labRequestTestReducer.labRequestTests,
    loading: state.labRequestTestReducer.loading,
    labRequestTest: state.labRequestTestReducer.labRequestTest,
    total: state.labRequestTestReducer.total,
    currentPage: state.labRequestTestReducer.currentPage,
  }), shallowEqual);
  // * Redux fin

  const reRender = () => {
    dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}&isInLaboratoryOperations=yes`));
  }

  const recarga = () => {
    window.location.reload();
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Ensayos de muestras')?.id),
      trackingStatus: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Ensayos de muestras')?.trackingStatus) ?? ''
    },
    validationSchema: Yup.object({
      trackingStatus: Yup.string().required("Defina el estatus"),
    }),
    onSubmit: (values, { resetForm }) => {
      updateLabOperationStatus(values);
      setTimeout(recarga, 900);
    }
  });

  const addPropertyLabRequestTest = (rowAuthTestIdsSelected) => {
    return {
      id: rowAuthTestIdsSelected,
      isInLaboratoryOperations: true,
    }
  }

  const modalRespInfo = (rowsAuthTestIdsSelected) => {
    Promise.all(
      rowsAuthTestIdsSelected.map((rowAuthTestIdsSelected) => dispatch(updateLabRequestTest(addPropertyLabRequestTest(rowAuthTestIdsSelected))))
    )
  }

  const addProperties = (values) => {
    return {
      ...values,
      id: rowInfo.id,
    }
  }

  const RegisterModalRespInfoUpdate = (values) => { // Para actualizar el estado
    dispatch(updateLabRequestTest(addProperties(values)));
    setRowInfo('');
    setTimeout(reRender, 500);
  }

  const onUpdate = (values) => {
    setRowInfo(values);
    setShowModal3(true);
  }

  const onDelete = (values) => {
    setRowInfo(values);
    setShowModal2(true);
  }

  const onDeleteConfirmation = () => {
    const updateValues = {
      id: rowInfo.id,
      isInLaboratoryOperations: false,
    }
    dispatch(updateLabRequestTest(updateValues));
    setRowInfo('');
    setTimeout(reRender, 500);
  }

  const getPagination = (params) => {
    dispatch(getLabRequestTests(`${params}&labRequest=${id}&isInLaboratoryOperations=yes`));
  }

  const columns = React.useMemo(
    () => [
      Expander,
      {
        Header: 'Norma',
        width: '16%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original.labTest?.norm?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Método',
        width: '16%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original.labTest?.method ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Nombre del ensayo',
        width: '16%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original.labTest?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Estatus de  Validación por Coordinación',
        width: '8%',
        Cell: ({ row }) => (
          row.original?.statusLaboratory === 'Autorizado' ?
            <div className='text-success'>{row.original?.statusLaboratory}</div> :
            row.original.statusLaboratory === 'Rechazado' ?
              <div className='text-danger'>{row.original?.statusLaboratory}</div> :
              <div className='text-warning'>{row.original?.statusLaboratory}</div>
        ),
      },
      {
        width: '10%',
        Header: "Acciones",
        Cell: ({ row }) => (
          <div>
            <div className="page-title-box d-flex align-items-center justify-content-center row">
              <BaseCustomButton
                disabled={
                  (role === userRoles.technicalAdvisor) ||
                  (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
                }
                color="primary"
                outline
                className="col-10 mb-2 p-1"
                icon="mdi-lead-pencil mdi-18px"
                label="Editar"
                onClick={() => onUpdate(row.original)}
              />

              <BaseCustomButton
                tag={Link}
                to={`/addInfoToTest/${id}/${row.original.id}`}
                color={role === userRoles.technicalAdvisor ? "success" : "success"}
                outline
                className="col-10 mb-2 p-1"
                icon="mdi-clipboard-check mdi-18px"
                label="Detalle"
              />

              <BaseCustomButton
                disabled={
                  (role === userRoles.technicalAdvisor) ||
                  (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
                }
                color="danger"
                outline
                className="col-10 mb-2 p-1"
                icon="mdi-delete mdi-18px"
                label="Eliminar"
                onClick={() => onDelete(row.original)}
              />
            </div>
          </div>
        ),
      },
    ],
    [role, generalStatus]
  )

  const columns2 = React.useMemo(
    () => [
      {
        Header: 'No. muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div className='text-center mb-2'>Código de muestra: {row.original?.labRequestSample?.sampleControlIdentifier ?? '-'}</div>
            <div className='text-center mb-1'>
              <QRCode value={row.original?.labRequestSample?.sampleControlIdentifier ?? '-'} size={50} />
            </div>
            <div className='text-center'>Folio de muestra: {row.original?.labRequestSample?.serviceIdentifier ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Descripción de la muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.labRequestSample?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Cantidad',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.labRequestSample?.quantity ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'UM',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.labRequestSample?.unitMeasure?.name ?? '-'}</div>
          </div>
        ),
      },
      {
        Header: 'Ensayos por muestra',
        width: '17%',
        Cell: ({ row }) => (
          <div>
            <div>{row.original?.essays ?? '-'}</div>
          </div>
        ),
      },
    ],
    []
  )

  const onAccept = () => {
    validation.submitForm();
  }

  const renderRowSubComponent = React.useCallback(
    ({ row }) => (
      <>
        {(row.original.labRequestTestSample) ? '' : dispatch(getLabRequestTests(`?limit=20&page=0&labRequest=${id}&isInLaboratoryOperations=yes`))}
        <TableNP isAddTableBorderStrap columns={columns2} data={row?.original?.labRequestTestSample} />
      </>
    ),
    []
  )

  return (

    <>
      <Nav tabs className="nav-tabs-custom nav-justified-left">

        <NavItem>
          <NavLink
            style={{ cursor: "pointer" }}
            className={classnames({ active: activeTab === '1' })}
            onClick={() => { profiletoggle('1'); }}
          >
            Ensayos de Muestras | Avance: {labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Ensayos de muestras')?.percentage.toFixed(2) ?? ''} %
          </NavLink>
        </NavItem>

      </Nav>

      <TabContent activeTab={activeTab} className="p-4 pt-2">

        <TabPane tabId='1'>

          <Form
            className="form-horizontal mt-2 mb-1"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >

            <div className='d-flex align-items-center w-100'>
              {/* Componente de última actualización */}
              <AnalysisRequestLastUpdate client={`${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Ensayos de muestras')?.updatedBy?.name ?? ''} ${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Ensayos de muestras')?.updatedBy?.surname ?? ''}`}
                date={`${moment(labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Ensayos de muestras')?.updatedAt).format('YYYY-MM-DD HH:mm') ?? ''}`} />
              {/* Botonera */}
              <div className='d-flex align-items-end justify-content-end pt-3 w-50'>

                {/* <AnalysisRequestStatusSelector disabled={(role === userRoles.technicalAdvisor)} /> */}

                <div className='mx-1'>

                  <label className='text-primary'>Estatus</label>

                  <select
                    disabled={
                      (role === userRoles.technicalAdvisor) || 
                      (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
                    }
                    defaultValue=""
                    name="trackingStatus"
                    className="form-select text-primary rounded-3"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.trackingStatus || ""}
                  >
                    {requestStatus.map((dir, index) => {
                      return <option key={index} value={dir.id}>{dir.value}</option>
                    })}
                  </select>

                </div>

                {
                  booleanValidation ? <AnalysisRequestNotifyButton disabled={booleanValidation} />
                    : <Link
                      to={{
                        pathname: `/process-notification/${id}`,
                      }}
                    >
                      <AnalysisRequestNotifyButton disabled={booleanValidation} />
                    </Link>
                }
                <AnalysisRequestSaveButton disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)} handleOnClick={() => setConfirmationModal(true)} />
                <ConfirmationModalTestReport props={props} onAccept={onAccept} showModal={confirmationModal} setShowModal={setConfirmationModal} message='¿Está seguro de cambiar el estatus?' />

              </div>
            </div>
          </Form>

          <div className='d-flex align-items-center justify-content-end pt-3'>
            <AnalysisRequestNewRegisterButton disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)} showModal={showModal1} setShowModal={setShowModal1} text={'Agregar ensayos'} />
            {
              (showModal1 === true)
                ? <TestOfSamplesTabModal props={props} id={id} showModal={showModal1} setShowModal={setShowModal1} modalRespInfo={modalRespInfo} />
                : null
            }
          </div>

          <br />

          <Card className='rounded-3' style={{ padding: 20 }}>
            {
              (showModal1 === false)
                ? <Table1 renderRowSubComponent={renderRowSubComponent} currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={labRequestTests} />
                : null
            }
            <LabOperationTestEditModal props={props} modalRespInfo={RegisterModalRespInfoUpdate} setShowModal={setShowModal3} showModal={showModal3} rowInfo={rowInfo} modalHeader='Edición de estado' />
            <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar Ensayos' modalBodyLabel='¿Está seguro que desea borrar el ensayo seleccionado?' />
          </Card>

        </TabPane>

      </TabContent>

    </>
  )
}
